import { Link as RouterLink, type LinkProps as RouterLinkProps } from 'react-router-dom';
import { forwardRef } from 'react';
import { prefetchRoute } from './route-prefetch';

interface NextLinkProps extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  href: string;
  replace?: boolean;
  prefetch?: boolean;
  children?: React.ReactNode;
}

const Link = forwardRef<HTMLAnchorElement, NextLinkProps>(
  ({ href, replace, prefetch, children, ...props }, ref) => {
    return (
      <RouterLink
        ref={ref}
        to={href}
        replace={replace}
        onMouseEnter={prefetch !== false ? () => prefetchRoute(href) : undefined}
        onTouchStart={prefetch !== false ? () => prefetchRoute(href) : undefined}
        {...props}
      >
        {children}
      </RouterLink>
    );
  }
);

Link.displayName = 'Link';

export default Link;
